import { render, staticRenderFns } from "./KeepInTouch.vue?vue&type=template&id=e29316dc&scoped=true"
import script from "./KeepInTouch.vue?vue&type=script&lang=js"
export * from "./KeepInTouch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29316dc",
  null
  
)

export default component.exports